import { combineReducers, Reducer } from 'redux';
import { reducer as checkoutReducer } from 'b2b-apps/shop/checkout/redux/checkout/reducer';
import { reducer as orderReducer } from 'b2b-apps/shop/checkout/redux/order/reducer';
import {
  CheckoutActions,
  CheckoutState,
} from 'b2b-apps/shop/checkout/redux/types';

const reducer: Reducer<CheckoutState, CheckoutActions> = combineReducers({
  checkout: checkoutReducer,
  order: orderReducer,
});

export { reducer };
